'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var PeerId = require('peer-id');

var _require = require('./utils'),
    ensureMultiaddr = _require.ensureMultiaddr;

var MultiaddrSet = require('./multiaddr-set'); // Peer represents a peer on the IPFS network


var PeerInfo = /*#__PURE__*/function () {
  function PeerInfo(peerId) {
    _classCallCheck(this, PeerInfo);

    if (!peerId) {
      throw new Error('Missing peerId. Use Peer.create() to create one');
    }

    this.id = peerId;
    this.multiaddrs = new MultiaddrSet();
    /**
     * Stores protocols this peers supports
     *
     * @type {Set<string>}
     */

    this.protocols = new Set();
    this._connectedMultiaddr = undefined;
  } // only stores the current multiaddr being used


  _createClass(PeerInfo, [{
    key: "connect",
    value: function connect(ma) {
      ma = ensureMultiaddr(ma);

      if (!this.multiaddrs.has(ma) && ma.toString() !== "/ipfs/".concat(this.id.toB58String())) {
        throw new Error('can\'t be connected to missing multiaddr from set');
      }

      this._connectedMultiaddr = ma;
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this._connectedMultiaddr = undefined;
    }
  }, {
    key: "isConnected",
    value: function isConnected() {
      return this._connectedMultiaddr;
    }
  }]);

  return PeerInfo;
}();

PeerInfo.create = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(peerId) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(peerId == null)) {
              _context.next = 6;
              break;
            }

            _context.next = 3;
            return PeerId.create();

          case 3:
            peerId = _context.sent;
            _context.next = 10;
            break;

          case 6:
            if (PeerId.isPeerId(peerId)) {
              _context.next = 10;
              break;
            }

            _context.next = 9;
            return PeerId.createFromJSON(peerId);

          case 9:
            peerId = _context.sent;

          case 10:
            return _context.abrupt("return", new PeerInfo(peerId));

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();

PeerInfo.isPeerInfo = function (peerInfo) {
  return Boolean(typeof peerInfo === 'object' && peerInfo.id && peerInfo.multiaddrs);
};

module.exports = PeerInfo;